import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { sortComplimentaryProductsByPrice } from './sort-complimentary-products-by-price';

export const getCheapestProduct = (products: TComplimentaryProductInfo[]): TComplimentaryProductInfo =>
  sortComplimentaryProductsByPrice(products)[0];
